import {sleep} from "@/shared/helper";

const state = () => ({
  socket:null
});

const actions = {
  setSocket({commit},socket)
  {
    commit('setSocket', socket);
  },
  async waitForSocket({state})
  {
    return new Promise(async (resolve,reject)=>{
      for (let i=0;i<100;i++)
      {
        if (state.socket)
        {
          resolve(state.socket);
          return;
        }
        await sleep(70);
      }
      reject(null);
    })
  }
};

const mutations = {
  setSocket(state,c)
  {
    state.socket = c;
  }
}

const getters = {
  getSocket(state)
  {
    return state.socket
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
